import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";

import OurProjects from "../../components/project/ourproject";
import { PlotsAdvantages } from "../../components/plots/plots";
import SliderVideo from "../../components/sliders/vsliders";
import ProjectTabs from "../../components/project_tabs/projectTab";
import Banner from "../../components/header/banner";

import HomeBanner from "../../assets/images/sangamam_1.jpg";
import HomeBanner2 from "../../assets/images/cove_2.jpg";
import HomeBanner4 from "../../assets/images/home_ban_1.jpeg";
import HomeBanner5 from "../../assets/images/home_ban_2.jpeg";
import HomeBanner6 from "../../assets/images/home_ban_3.jpeg";

/* new 28.06.2026 */
/* import home_banner_1 from "../../assets/images/home_banner_1.jpeg";
import home_banner_2 from "../../assets/images/home_banner_2.jpeg";
import home_banner_3 from "../../assets/images/home_banner_3.jpeg"; */

import HomeGowriBanner from "../../assets/images/home_gowri_banner.jpg";
import HomeGreenCoveBanner from "../../assets/images/home_greencove_banner.jpg";
import HomeSangamamBanner from "../../assets/images/home_sangamam_banner_2.jpg";
export default function HomePage() {
  return (
    <div>
      <Banner
        bannerImages={[
          /* HomeBanner,
          HomeBanner2,
          HomeBanner4,
          HomeBanner5,
          HomeBanner6, */
          /*  home_banner_1,
          home_banner_2,
          home_banner_3, */
          HomeGowriBanner,
          HomeGreenCoveBanner,
          HomeSangamamBanner,
        ]}
        showForm={false}
      />

      <OurProjects />
      <PlotsAdvantages />
      <SliderVideo />
      <ProjectTabs />
    </div>
  );
}
